// Module menu (HANDOFF §1): 200 px column at ≥1100; at narrower widths the
// same rows render as the rail flyout (compact/tablet) or a chip strip under
// the top bar (phone). Rows are already gated (gates.visibleMenu). A row that
// opens a section carries `section`: its eyebrow («الإعداد», «الشركات» —
// board 27) renders before the first visible row of that section in the
// column and the flyout, never in the phone strip.

import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useT } from './erp-context';
import { activeMenuKey, labelOf, type RailEntry } from './gates';

export interface ModuleMenuProps {
  entry: RailEntry | null;
  variant?: 'column' | 'strip' | 'list';
  onNavigate?: () => void;
}

export function ModuleMenuItems({
  entry,
  onNavigate,
  className = 'e-menu-items',
  sections = true,
}: {
  entry: RailEntry;
  onNavigate?: () => void;
  className?: string;
  /** Draw the section eyebrows (off in the phone chip strip). */
  sections?: boolean;
}) {
  const { pathname, search } = useLocation();
  const t = useT();
  const activeKey = activeMenuKey(entry.menu, pathname, search);
  let section: string | undefined;
  return (
    <div className={className}>
      {entry.menu.map((item) => {
        const eyebrow = sections && item.section && item.section !== section ? item.section : null;
        if (item.section) section = item.section;
        return (
          <Fragment key={item.key}>
            {eyebrow && <div className="e-menu-section">{eyebrow}</div>}
            <Link to={item.to} className="e-menu-item" aria-current={item.key === activeKey ? 'page' : undefined} onClick={onNavigate}>
              {labelOf(item, t)}
            </Link>
          </Fragment>
        );
      })}
    </div>
  );
}

export function ModuleMenu({ entry, variant = 'column', onNavigate }: ModuleMenuProps) {
  const t = useT();
  if (variant === 'strip') {
    if (!entry || entry.menu.length < 2) return null;
    return (
      <nav className="e-menustrip" aria-label={labelOf(entry, t)}>
        <ModuleMenuItems entry={entry} onNavigate={onNavigate} className="e-menustrip-items" sections={false} />
      </nav>
    );
  }
  if (variant === 'list') {
    return entry ? <ModuleMenuItems entry={entry} onNavigate={onNavigate} /> : null;
  }
  const title = entry ? labelOf(entry, t) : '';
  return (
    <nav className="e-menu" aria-label={title || 'قائمة الوحدة'} data-testid="module-menu">
      <div className="e-menu-title">{title}</div>
      {entry && <ModuleMenuItems entry={entry} onNavigate={onNavigate} />}
    </nav>
  );
}
